// File: Services/employeeService.js
import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

const employeeService = {

  checkWorkEmailExists: async (workEmail) => {
    try {
      const res = await axiosInstance.get(API.employee.checkWorkEmailExists(workEmail));
      return res.data;
    } catch (err) {
      console.error("Error checking work email", err);
      throw err;
    }
  },


  getJobTitles: async (departmentId) => {
    try {
      const res = await axiosInstance.get(API.jobTitle.getListByLookup(departmentId)); 
      return res.data || [];
    } catch (err) {
      console.error("Error fetching job titles", err);
      throw err;
    }
  },

  getDesignationsByLevels: async () => {
  try {
    const res = await axiosInstance.get(API.designation.getAll);
    return res.data;
  } catch (err) {
    console.error("Error fetching designations", err);
    throw err;
  }
},

  
  getSupervisors: async (designationId,departmentId) => {
    try {
      const url = API.employee.supervisors(designationId, departmentId);
      const res = await axiosInstance.get(url);
      return res.data || [];
    } catch (err) {
      console.error("Error fetching supervisors", err);
      throw err;
    }
  },

getDirectReports: async (supervisorId) => {
  try {
    const url = API.employee.directReports(supervisorId); // call function
        const res = await axiosInstance.get(url);
    return res.data || [];
  } catch (err) {
    console.error("Error fetching direct reports", err);
    throw err;
  }
},

  // Step 4: Get Skills
  getSkills: async () => {
    try {
      const res = await axiosInstance.get(API.skills.getList); 
      return res.data || [];
    } catch (err) {
      console.error("Error fetching skills", err);
      throw err;
    }
  },

  // Step 4: Create Employee
  createEmployee: async (employeeData) => {
    try {
      const payload = {
        JobApplicantId: employeeData.jobApplicantId,
        WorkEmail: employeeData.workEmail,
        JobTitleId: employeeData.jobTitleId,
        "Employment.HiringDate": employeeData.hiringDate,
        "Employment.ProbationStartDate": employeeData.probationStartDate,
        "Employment.ProbationEndDate": employeeData.probationEndDate,
        "Employment.DesignationId": employeeData.designationId,
        "Employment.PayType": employeeData.payType === "Monthly" ? 0 : 1, // Adjust if backend differs
        "Employment.BaseSalary": employeeData.baseSalary,
        "Reporting.SupervisorId": employeeData.supervisorId,
        "Reporting.ReassignDirectReports": employeeData.reassignDirectReports,
        "Skills.SkillIds": employeeData.skillIds,
        "Skills.CustomSkills": employeeData.customSkills,
      };

      const res = await axiosInstance.post(API.employee.create, payload);
      return res.data;
    } catch (err) {
      console.error("Error creating employee", err);
      throw err;
    }
  },

  getDepartments: async () => {
    try {
      const url = API.department.getListByLookup;

const res = await axiosInstance.get(url);   
   return res.data || [];
    } catch (err) {
      console.error("Error fetching supervisors", err);
      throw err;
    }
  },


};

export default employeeService;